<template>
    <div class="mt-5">
        <h1>{{ code }}</h1>
        <p>{{ message }}</p>
    </div>
</template>

<script>
export default {
    props: ['code', 'message'],
    data () {
        return {
            
        }
    }

}

</script>
